<template>
    <teleport to="body" v-if="isVisible || isCreated">
        <div class="renter-modal" ref="modal" :class="[className, themeStyle]" v-show="isVisible" v-bind="$attrs">
            <div class="renter-modal_header">
                <div class="title-section">
                    <h4>{{ title }}</h4>
                    <h6 v-if="subtitle?.length">{{ subtitle }}</h6>
                    <slot name="modal-header-title"></slot>
                </div>
                <div class="buttons">
                    <slot name="modal-header-button"></slot>
                    <ideo-button v-if="link" @click="() => { $router.push(link) }" :class="{'d-none d-md-block': hideLinkMobile}">{{ $t('[[[Rozwiń]]]') }}</ideo-button>
                    <ideo-button @click="kill()">{{ $t('[[[Zamknij]]]') }}</ideo-button>
                </div>
            </div>
            <div class="renter-modal_content scroll" :class="{ ['full-height']: contentFullHeight !== undefined }">
                <slot name="modal-content"></slot>
            </div>
            <div class="renter-modal_footer">
                <slot name="modal-footer"></slot>
            </div>
        </div>
        <div v-if="isVisible" class="modal-overlay" @click="kill()"></div>
    </teleport>
</template>

<script lang="ts">
import { Prop } from '@/helpers/Decorators';
import { Options, Vue } from 'vue-class-component';
import { RouteLocation } from 'vue-router';

@Options({
    name: 'renter-side-modal',
    emits: ['closeRenterModalEvent', 'initRenterModalEvent']
})
export default class RenterSideModal extends Vue
{
    @Prop({ default: undefined }) public contentFullHeight: boolean;

    public themeStyles: string[] = ['default-theme', 'c-dark-theme'];
    public link: RouteLocation;
    public title: string;
    public subtitle: string;
    public isVisible: boolean = false;
    public isCreated: boolean = false;
    public className: string = '';
    public hideLinkMobile: boolean = false;

    public create(): void
    {
        this.isCreated = true;
    }

    public async init(
        title: string = null,
        link: RouteLocation = null,
        subtitle: string = null,
        hideLinkMobile: boolean = false
    ):Promise<void>
    {
        this.link = link;
        this.title = title;
        this.subtitle = subtitle;
        this.isVisible = true;
        this.hideLinkMobile = hideLinkMobile;
        await this.$nextTick();
        this.scrollModalToTop();
        this.$emit('initRenterModalEvent');
    }

    public kill():void
    {
        this.className = 'slide-out';
        setTimeout(() =>
        {
            this.className = '';
            this.isVisible = false;
            this.$sitemap.extraCrumb = '';
            this.$emit('closeRenterModalEvent');
        }, 500);
    }

    public hide(): void
    {
        this.className = 'slide-out';
    }

    public show(): void
    {
        this.className = '';
    }

    private scrollModalToTop(): void
    {
        if (this.$refs.modal)
        {
            const modal: any = this.$refs.modal;

            modal.scrollTo(0, 0);
        }
    }

    public get themeStyle(): string
    {
        const id = this.$store.state.common.theme.themeId;

        return this.themeStyles[id];
    }
}
</script>
<style lang="scss" scoped>
    .renter-modal{
        position: fixed;
        top: 0;
        right: 0;
        display: flex;
        flex-direction: column;
        @media (max-width: 500px){
            width: 100vw;
            height: 100dvh;
        }
        width: 500px;
        height: 100vh;
        background: var(--cui-modal-bg);
        padding: 15px;
        opacity: 0;
        z-index: 10013;
        animation: slide-in .4s ease-in-out forwards;
        box-shadow: 0 1px 5px 0 rgb(60 75 100 / 20%);
        &.slide-out{
            animation: slide-out .4s ease-in-out forwards;
        }
        @keyframes slide-in {
            from{
                transform: translateX(100%);
                opacity: 0;
            }
            to{
                transform: translateX(0);
                opacity: 1;
            }
        }
        @keyframes slide-out {
            from{
                transform: translateX(0);
                opacity: 1;
            }
            to{
                transform: translateX(100%);
                opacity: 0;
            }
        }

        &_header{
            padding: 0 0 10px 10px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .title-section{margin: 5px 0 0;}
            .buttons{
                display: flex;
                button{
                    margin: 0 5px;
                }
            }
        }
        &_content{
            &.full-height{
                height: 100%;
            }
        }
        &_footer{
            margin-top: auto;
        }
    }
</style>
<style lang="scss">
    .modal-overlay::before{
        content: '';
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background: rgba(0, 0, 0, 0.3);
        transition: opacity 0.5s;
        z-index: 10012;
    }
</style>
